// extracted by mini-css-extract-plugin
module.exports = {"load-more":"styles_load-more__3DwPk"};